import React from "react";
import { Box, Typography } from "@mui/material";
import { Link, useLocation } from "react-router-dom";

const FooterSection: React.FC = () => {
  const location = useLocation();
  return (
    <Box
      sx={{
        backgroundColor: "#212121",
        borderBottom: "2px solid #DAAA00",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#212121",
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "flex-start", sm: "center" },
          gap: { xs: 1, sm: 2 },
          flexWrap: "wrap",
          height: "auto",
          px: 4,
          py: { xs: 2, sm: 0 },
          borderBottom: "5px solid #DAAA00",
        }}
      >
        <Typography
          variant="body2"
          className="f-14 pr-2"
          sx={{ color: "#FFFFFF", fontWeight: 400 }}
        >
          Can we help?
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "row", sm: "row" },
            alignItems: { xs: "flex-start", sm: "center" },
            gap: { xs: "8px 16px", sm: 0 },
            flexWrap: "wrap",
            height: "auto",
          }}
        >
          <a
            href="https://docs.google.com/document/d/1nfd7F0bu7ZmYdyPiubfpxxO2-fjHd-7xD0L_r1MolmY/preview?tab=t.0"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none", color: "#fffff" }}
            className=" commonLink  f-14"
          >
            Training Manuals
          </a>

          <a
            href="https://www.royalenfield.com/in/en/home/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none", color: "#fffff" }}
            className=" commonLink  f-14"
          >
            About Royal Enfield
          </a>

          <Link
            to="/companyAddress"
            className={`commonLink f-14 ${
              location.pathname === "/companyAddress" ? "active_link" : ""
            }`}
            style={{ textDecoration: "none" }}
          >
            Company Addresses
          </Link>
        </Box>
      </Box>
      <div style={{ border: "1px solid #fff" }}></div>
    </Box>
  );
};

export default FooterSection;
